import React, { useEffect, useState, useCallback } from 'react';
import { getDownloadURL, listAll, ref, uploadBytes, deleteObject } from 'firebase/storage';
import { storage } from '../../firebase';
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from '../../firebase';

const ImageEditor = () => {
  const { hubId } = useParams();
  const navigate = useNavigate();
  const folderPath = `${hubId}/dashboard-data/`;

  const [imageUrls, setImageUrls] = useState([]);
  const [imageRefs, setImageRefs] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [hubName, setHubName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // nuevo estado para archivo
  const [viewMode, setViewMode] = useState('grid');
  const [imageSelectLabel, setImageSelectLabel] = useState('');


  useEffect(() => {
    const fetchHubName = async () => {
      try {
        const hubRef = doc(db, "private-hubs", hubId);
        const hubSnap = await getDoc(hubRef);
        if (hubSnap.exists()) {
          const data = hubSnap.data();
          setHubName(data.Nombre);
          setViewMode(data.layoutMode || 'grid');
          setImageSelectLabel(data.dashboardImgLabel || 'Selecciona una imagen:');
        } else {
          setHubName("Hub no encontrado");
        }
      } catch (error) {
        console.error("Error al obtener datos del hub:", error);
        setHubName("Error al cargar datos");
      }
    };

    fetchHubName();
  }, [hubId]);

  const fetchImages = useCallback(async () => {
    try {
      const folderRef = ref(storage, folderPath);
      const result = await listAll(folderRef);
      const urls = await Promise.all(
        result.items.map((itemRef) => getDownloadURL(itemRef))
      );
      setImageUrls(urls);
      setImageRefs(result.items);
    } catch (error) {
      console.error('Error al obtener las imágenes:', error);
    }
  }, [folderPath]);


  const toggleViewMode = async () => {
    const newMode = viewMode === 'grid' ? 'single' : 'grid';
    try {
      const hubRef = doc(db, "private-hubs", hubId);
      await updateDoc(hubRef, { layoutMode: newMode });
      setViewMode(newMode);
    } catch (error) {
      console.error("Error al actualizar viewMode:", error);
    }
  };


  useEffect(() => {
    fetchImages();
  }, [hubId, fetchImages]);

  // nuevo handler para seleccionar archivo
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar extensión
    const validTypes = ['image/jpeg', 'image/png'];
    if (!validTypes.includes(file.type)) {
      alert('Solo se permiten archivos .jpg y .png');
      e.target.value = null; // limpia input
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
  };

  // nuevo handler para subir archivo
  const handleUpload = async () => {
    if (!selectedFile) return;

    const storageRef = ref(storage, `${folderPath}${selectedFile.name}`);
    setUploading(true);

    try {
      await uploadBytes(storageRef, selectedFile);
      await fetchImages();
      setSelectedFile(null); // limpiar archivo seleccionado
    } catch (error) {
      console.error('Error al subir la imagen:', error);
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (index) => {
    const imageRef = imageRefs[index];
    if (!imageRef) return;

    try {
      await deleteObject(imageRef);
      await fetchImages();
    } catch (error) {
      console.error('Error al eliminar la imagen:', error);
    }
  };

  return (
    <div>
      <div className='header-container'>
        <header className="header">
          <h1 className="header-title-lobby">Editor de Imágenes para el hub "{hubName || hubId}"</h1>
          <button
            className="logout-button"
            onClick={() => navigate(-1)}
            style={{ position: 'absolute', right: '20px' }}
          >
            ← Volver
          </button>
        </header>
      </div>

      <div className='data-box' style={{ margin: '20px', padding: '20px', textAlign: 'center' }}>
        Vista actual del dashboard: {viewMode !== 'grid' ? 'individual' : 'en cuadrícula'}
        <button
          onClick={toggleViewMode}
          style={{
            marginLeft: '20px',
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            backgroundColor: '#0F70B8',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          Cambiar vista 
        </button>
          <span style={{marginLeft: '30px', marginRight:'10px'}}>Texto para etiqueta de selector</span>
          <input
            type="text"
            value={imageSelectLabel}
            onChange={(e) => setImageSelectLabel(e.target.value)}
            style={{
              padding: '8px',
              width: '300px',
              marginRight: '10px',
              borderRadius: '6px',
              border: '1px solid #ccc',
            }}
          />
          <button
            onClick={async () => {
              try {
                const hubRef = doc(db, "private-hubs", hubId);
                await updateDoc(hubRef, { dashboardImgLabel: imageSelectLabel });
                alert("Texto actualizado correctamente");
              } catch (error) {
                console.error("Error al actualizar el texto:", error);
                alert("Hubo un error al actualizar el texto");
              }
            }}
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              backgroundColor: '#0F70B8',
              color: 'white',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Guardar texto
          </button>
        </div>
    

      <div className='dashboard-grid'>
        {imageUrls.map((url, index) => (
          <div className='data-box' key={index} style={{ position: 'relative', maxWidth: '80%', padding: '10px' }}>
            <img
              src={url}
              alt={`Imagen ${index + 1}`}
              style={{
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            />
            <button
              onClick={() => handleDelete(index)}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                backgroundColor: 'rgba(200,0,0,0.8)',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 10px',
                cursor: 'pointer',
              }}
            >
              Borrar
            </button>
          </div>
        ))}
      </div>


      <div className='data-box' style={{ margin: '20px', padding: '20px', textAlign: 'center' }}>
        <input
          type="file"
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
        />
        <button
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
          style={{
            marginLeft: '10px',
            padding: '8px 16px',
            backgroundColor: selectedFile && !uploading ? '#0F70B8' : '#ccc',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: selectedFile && !uploading ? 'pointer' : 'not-allowed',
          }}
        >
          {uploading ? 'Subiendo...' : 'Subir archivo'}
        </button>
      </div>
    </div>
  );
};

export default ImageEditor;
